import Vue from 'vue'
import VueRouter from 'vue-router'
import common from '../../router/index'
import discover from '../../router/discover'

Vue.use(VueRouter)

discover.push.apply(discover, common)

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: discover
})

export default router
